import axios from "axios";
import { useQuery, type UseQueryOptions } from "react-query";
import type { GeopuntLocation, GeopuntResponse } from "src/types/geopunt";

export const useGeopuntLocation = (query: string, options: Pick<UseQueryOptions, "enabled">, type?: number) => {
  const baseUrl = "https://geo.api.vlaanderen.be/geolocation/v4";
  const queryOptions = {
    q: query,
    c: 5,
    type: type,
  };
  const fetch = async () => {
    const response = await axios.get<GeopuntResponse>(`${baseUrl}/Location`, {
      params: queryOptions,
    });
    const deserializedLocations: GeopuntLocation[] = response.data.LocationResult.map((item) => {
      const houseNumber = item.Housenumber ? ` ${item.Housenumber}` : ``;
      return {
        id: item.ID,
        thoroughFarename: item.Thoroughfarename ? `${item.Thoroughfarename}${houseNumber}` : null,
        municipality: item.Municipality,
        bbox: item.BoundingBox,
      };
    });
    return deserializedLocations;
  };
  return useQuery(["geopunt-location", query, type], fetch, {
    refetchInterval: Infinity,
    suspense: false,
    staleTime: Infinity,
    ...options,
  });
};
